import { getBroadcastRouteMatch } from 'actions/utils';
import { BROADCAST_UPDATE_SETTINGS } from 'actions/Types';
import {
  AUTO_MUTE_TOGGLE,
  MUTE_MEETING_AUDIO_CHANGE,
  TOGGLE_ADD_SELF_LIVE,
  TOGGLE_LAYOUT_ANIMATION
} from 'store/eventConstants';

export default function updateBroadcastSettings(updates) {
  return (dispatch, getState, socket) => {
    const action = {
      type: BROADCAST_UPDATE_SETTINGS,
      request: async apiClient => {
        const match = getBroadcastRouteMatch(getState);
        const {
          meeting: { attendeeResponse }
        } = getState();

        const { teamId, eventId, broadcastId } = match.params;

        const broadcast = await apiClient.broadcast.updateSettings(
          teamId,
          eventId,
          broadcastId,
          updates
        );

        const notifyingDirector = attendeeResponse?.Attendee?.AttendeeId;
        emitInterestingSettingUpdates(
          socket,
          updates,
          broadcastId,
          notifyingDirector
        );
        return broadcast;
      }
    };

    dispatch(action);
  };
}

const settingEventMap = {
  muteMeetingAudio: MUTE_MEETING_AUDIO_CHANGE,
  addSelfLive: TOGGLE_ADD_SELF_LIVE,
  layoutAnimations: TOGGLE_LAYOUT_ANIMATION,
  autoMutePresenters: AUTO_MUTE_TOGGLE
};

/**
 * THis will emit required event when the settings property is updated
 * @param {Object} socket The active socket reference
 * @param {Object} updates has the current updated property from settings
 * @param {Object} broadcastId the broadcast id
 * @param {String} notifyingDirector
 */
const emitInterestingSettingUpdates = (
  socket,
  updates,
  broadcastId,
  notifyingDirector
) => {
  Object.keys(updates).forEach(key => {
    if (settingEventMap[key]) {
      socket.emit(settingEventMap[key], {
        broadcastId,
        notifyingDirector,
        [key]: updates[key]
      });
    }
  });
};
